<template>
	<div id="app">
		<HNB single-title="联系我们"></HNB>
		
		<div id="Relation">
			<div class="center" >
				<div class="box" >
					 
					<div class="box1">
						<div class="svg"><SvgIcon svg-name="lfSign1" size="40"></SvgIcon></div>
						<div class="span"><strong>厦门乐范健康科技有限公司</strong></div>
					</div>
					
					<div class="box2">
						
		                        <div class="place">
									<div class="svg"><SvgIcon svg-name="place" size="20"></SvgIcon></div>
									<div class="span">厦门市湖里区火炬新科广场3号楼7楼</div>
								</div>
								<div class="phone">
									<div class="svg"><SvgIcon svg-name="telephone" size="20"></SvgIcon></div>
									<div class="span">400-101-8969</div>
								</div>
								<div class="email">
									<div class="svg"><SvgIcon svg-name="email" size="21"></SvgIcon></div>
									<div class="span">service@lfwellness.cn</div>
								</div>
								
								
		            </div>
					
					<div class="box3">
					<!-- <div class="img"><img style="width: 5rem;height: 5rem;" :src="img1">微信公众号</div>
					<div class="img" style="padding-left: 1.875rem;"><img style="width: 5rem;height: 5rem;" :src="img3">新浪微博</div> -->
					<div class="img"><img style="width: 6rem;height: 6rem;" :src="img4">乐范小红书</div>
					<div class="img" style="padding-left: 1.875rem;"><img style="width: 6rem;height: 6rem;" :src="img5">乐班小红书</div>
					<div class="img" style="padding-left: 1.875rem;"><img style="width: 6rem;height: 6rem;" :src="img6">Zmind小红书</div>
					</div>
					 
					
					
					 
				</div>
			
			 <div class="box4"><img style="width: auto;height: 100%;" :src="img2"></div> 
			</div>
		</div>
		<BS :BsTitle="bsTitle"></BS>
	</div>
</template>
	
<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import BS from '../components/bottomShow.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	export default {
		name: "app",
		
		components: {
			HNB,
			BS,
			SvgIcon
		},
		data(){
			return{
				bsTitle:['服务支持','联系我们'],
				img1:this.GLOBAL.imgHost + '/images/gongzonghao.png',
				img3:this.GLOBAL.imgHost + '/images/weiboimg.png',
				img2:this.GLOBAL.imgHost + '/images/relation-bg.png',
				img4:this.GLOBAL.imgHost + '/images/lefan-xiaohongshu.jpg',
				img5:this.GLOBAL.imgHost + '/images/leband-xiaohongshu.jpg',
				img6:this.GLOBAL.imgHost + '/images/zmind-xiaohongshu.jpg',
			}
		}
	}
</script>

<style>
	
	#Relation .center{
		width:100%;
		background:linear-gradient(90deg,rgba(0,199,133,1),rgba(9,219,184,1));
		/* padding-top: 80px; */
		/* background-image:url(../assets/images/relation-bg.png); 
		background-repeat:no-repeat;
		overflow: hidden;
		background-size:100% auto; */
		position: relative;
		overflow: hidden;
	}
	#Relation .center .box{
		width: 100%;
		max-width: 1024px;
		min-height:20.7rem;
		margin: 10rem auto 6.25rem;
		padding-left: 30px;
		position: relative;
/* 		position: relative;
		
		    left: 3%;
		clear: both;
		margin-top: 3%; */
		z-index: 90;
	}
	#Relation .center .box1{
		width:28.3125rem;
		height:3.625rem;
		font-size:2rem;
		font-family:Alibaba PuHuiTi-M;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:1.25rem;
		cursor: pointer;
	}
	#Relation .center .box1 .svg{
		float: left;
		opacity: 0.5;
	}
	#Relation .center .box1 .span{
		
		    position: relative;
		    left: -8%;
		    top: 30%;
		
	}
	#Relation .center .box2{
		width:20.4375rem;
		height:9.625rem;
		font-size:1rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		text-decoration:underline;
		color:rgba(255,255,255,1);
		line-height:1.8125rem;
		margin-top: 1.875rem;
		text-align: left;
		cursor: pointer;
		margin-left: 0.9375rem;
		
	}
	#Relation .center .box2 .place{
		height:2.1875rem;
	}
	#Relation .center .box2 .place .svg{
		    width:  2.5rem;
		float: left;
		line-height: 2.1875rem;
		
	}
	#Relation .center .box2 .place .svg .icon{
		
		position: relative;
		top: 50%;
		
	}
	
	#Relation .center .box2 .phone{
		height:2.1875rem;
	}
	#Relation .center .box2 .phone .svg{
		    width:  2.5rem;
		float: left;
		line-height: 2.1875rem;
	}
	
	#Relation .center .box2 .email{
		height:2.1875rem;
	}
	#Relation .center .box2 .email .svg{
		    width: 2.5rem;
		float: left;
		line-height: 2.7rem;
	}
	
	#Relation .center .box3 {
		width: 27rem;
		height: 6rem;
		    clear: both;
		   
			cursor: pointer;
		
	}
	#Relation .center .img{
		width:6.75rem;
		height:4.6875rem;
		font-size:1rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		color:rgba(255,255,255,1);
		line-height:1.0625rem;
		float: left;
		padding: 2%;
		
		
	}
	#Relation .box4{
		min-width: 50%;
		height: 100%;
		position: absolute;
		top: 0;
		right: 0;
		overflow: hidden;
		    /* margin-top: -23.875rem; */
		    /* left: 58%; */
		z-index: 1;
		 
	}
</style>
